var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEco = function SvgEco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2 26.133c-1-1-1.783-2.155-2.35-3.466A10.15 10.15 0 0 1 4 18.6c0-1.4.267-2.783.8-4.15.533-1.367 1.4-2.65 2.6-3.85.778-.778 1.739-1.444 2.883-2 1.145-.555 2.5-.994 4.067-1.317 1.567-.322 3.356-.516 5.367-.583 2.01-.067 4.26.011 6.75.233.177 2.356.233 4.523.166 6.5-.066 1.978-.25 3.762-.55 5.35-.3 1.59-.722 2.978-1.266 4.167-.545 1.189-1.217 2.183-2.017 2.983-1.178 1.178-2.428 2.04-3.75 2.584a10.546 10.546 0 0 1-4.05.816c-1.444 0-2.856-.283-4.233-.85-1.378-.566-2.567-1.35-3.567-2.35Zm3.733-.533a7.41 7.41 0 0 0 1.984.817 8.69 8.69 0 0 0 2.083.25 7.916 7.916 0 0 0 3.033-.617c1-.411 1.956-1.072 2.867-1.983.4-.4.806-.961 1.217-1.684.41-.722.766-1.666 1.066-2.833.3-1.167.528-2.578.684-4.233.155-1.656.177-3.628.066-5.917a76.01 76.01 0 0 0-3.683-.05 29.589 29.589 0 0 0-4.083.317c-1.356.2-2.645.522-3.867.966-1.222.445-2.222 1.056-3 1.834-1 1-1.689 1.989-2.067 2.966-.377.978-.566 1.923-.566 2.834 0 1.31.25 2.46.75 3.45.5.989.939 1.683 1.316 2.083.934-1.778 2.167-3.483 3.7-5.117a19.408 19.408 0 0 1 5.367-4.016 24.348 24.348 0 0 0-4.183 4.75c-1.19 1.766-2.084 3.827-2.684 6.183Z",
    fill: "#F92"
  }))));
};
export default SvgEco;